import { render, staticRenderFns } from "./OperaInterfaceConfigWindow.vue?vue&type=template&id=621ddb28&"
import script from "./OperaInterfaceConfigWindow.vue?vue&type=script&lang=js&"
export * from "./OperaInterfaceConfigWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports